import React, { useEffect } from 'react';
import Button from '../common/Button';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 py-6 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="logout-modal-title"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-white dark:bg-slate-800 shadow-2xl flex flex-col border border-transparent dark:border-slate-700 overflow-hidden transform transition-all scale-100 opacity-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 text-center">
          <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto mb-4 shadow-inner">
            <i className="fas fa-sign-out-alt text-2xl text-red-600 dark:text-red-400"></i>
          </div>
          
          <h2 id="logout-modal-title" className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
            Ready to Leave?
          </h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm">
            Are you sure you want to log out of your BizTracker account?
          </p>
        </div>
        
        <div className="p-4 bg-slate-50 dark:bg-slate-700/50 flex gap-3 border-t border-slate-100 dark:border-slate-700">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="flex-1"
            onClick={onConfirm}
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
